// extracted by mini-css-extract-plugin
export default {"product__title":"product__title_GOaQB6Bg"};